import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["collapse", "arrowIcon"];

  toggle(e) {
    const node = e.currentTarget.parentNode;
    const status = this.check_toggle_status(node);

    if(status) {
      this.toggle_icon(false);
      $(this.collapseTarget).collapse("toggle");
    }
    else {
      this.toggle_icon(true);
      $(this.collapseTarget).collapse("toggle");
    }
  }

  toggle_icon(open) {
    this.arrowIconTarget.classList.toggle("fa-angle-down", open);
    this.arrowIconTarget.classList.toggle("fa-angle-right", !open);
  }

  check_toggle_status(node) {
    return node.querySelector(".collapse.card-body.show");
  }
}
